var poll_default = {
  "fontElementMap": "DNV72",
  "container": "SP2Wc",
  "fullscreen": "a94yk",
  "background_overlay": "xprJw",
  "with_image": "E3LeF",
  "options": "vXG45",
  "webview": "Lw3OL",
  "grid": "BAEWi",
  "option": "_5QYxM",
  "cta_button": "Riv4i",
  "add_option": "PvGgQ",
  "see_more": "ne1hY",
  "list": "ILNZn",
  "column": "w7G35",
  "additional_note": "R6bSw",
  "spinner": "_9gUoG",
  "spin": "NI6kv",
  "shown": "rA3S9",
  "error": "JL-Ts"
};
export {
  poll_default as default
};
//# sourceMappingURL=poll-scss.js.map
